import { round } from "lodash";
import { useRootSelector } from "@/infrastructure/hooks";
import { BacktestSel, BacktestType } from "@/features/backtest";
import { oc } from "ts-optchain";

export const useRiskReturnData = () => {
  const result = useRootSelector(BacktestSel.result);
  const resultNameMap = useRootSelector(BacktestSel.resultNameMap);
  const initialCash = result.initialCash;
  const groupResult = result.groupResult;
  const groupOrder: Record<string, number> = { strategy: 0, longTerm: 1, peerStrategy: 2 };
  const singleResult = oc(result).singleResult([]);

  return [
    ...Object.entries(groupResult)
      .sort(([a, _a], [b, _b]) => oc(groupOrder[a])(-1) - oc(groupOrder[b])(-1))
      .map(([k, v]) => createStats(resultNameMap[k as keyof BacktestType.GroupResult], v)),
    ...singleResult.map(e => createStats(e.strategy, e.results))
  ];

  function createStats(name: string, btResult?: BacktestType.BacktestResult) {
    return btResult
      ? {
          name,
          cumRtn: round((btResult.portfolioFinalValue / initialCash - 1) * 100, 2),
          annualRtn: btResult.portfolioStatistics.riskReturn.cagr,
          annualVol: btResult.portfolioStatistics.riskReturn.annualVolatility,
          sharpeRatio: btResult.portfolioStatistics.riskReturn.sharpeRatio
        }
      : {
          name,
          cumRtn: "NA",
          annualRtn: "NA",
          annualVol: "NA",
          sharpeRatio: "NA"
        };
  }
};
